var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!!_vm.countDown)?_c('div',{staticClass:"countDown",style:(_vm.countDownStyle)},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.text)+" ")]),_vm._v(_vm._s(_vm.countDown)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }